import { MessageCircle } from "lucide-react";
import { BRAND } from "../data/brand";

export default function FloatingWhatsApp() {
  return (
    <a
      href={BRAND.whatsapp_link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 group hidden md:block"
    >
      <span className="absolute -inset-1 rounded-full bg-accent/30 blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-foreground text-background border border-accent/30 shadow-2xl hover:scale-105 transition-transform duration-300">
        <MessageCircle size={20} strokeWidth={1.5} />
      </span>
    </a>
  );
}
